import App from "@/App.vue"
import sentry from "@/configurations/sentry"
import { SanitizeHtml, Tooltip } from "@/directives"
import router from "@/router"
import { useAuthStore } from "@/stores"
import { useEngineModelPlugin } from "@/utils/useEngineModel"
import { EngineError } from "@/utils/useEngineModel/error"
import KsDesignSystem from "@kaleidoscope-solutions/ks-design-system"
import { useTimeAgo } from "@vueuse/core"
import { createPinia } from "pinia"
import { createApp } from "vue"

import { PromiseDialog } from "vue3-promise-dialog"
import "@total-typescript/ts-reset"
import "@/style.css"

// Create app
const app = createApp(App)

app.use(sentry)

// The Engine will import this so it can produce valid error objects.
const global = globalThis as any
global.EngineError = EngineError

app.use(router)

// Store
const pinia = createPinia()
app.use(pinia)

// using auth0
const { authService } = useAuthStore()
app.use(authService)

app.use(useEngineModelPlugin)

// Design System
app.use(KsDesignSystem)

app.directive("tooltip", Tooltip)
app.directive("sanitize-html", SanitizeHtml)

app.use(PromiseDialog, {})

// Mount app
app.mount("#app")

const timeAgo = useTimeAgo(new Date(__BUILD_DATE__))

// eslint-disable-next-line no-console
console.info(
  `%cKaleidoscope`,
  "font-weight: bold; font-size: 1.25rem;color: rgb(164, 20, 247); text-shadow: 1px 1px 0 rgb(244, 217, 255)"
)
// eslint-disable-next-line no-console
console.info(
  `%cUI: v.${__VERSION__}
Engine: v.${__ENGINE_VERSION__}
Built & Deployed: ${timeAgo.value}`,
  "color: rgb(164, 20, 247);"
)
